export const PROMO_PAGE_SOCIAL_MEDIA = 'promoPage'
export const SHELF_LEFT_SOCIAL_MEDIA = 'shelfLeft'
export const OVERVIEW_LOGUE_SOCIAL_MEDIA = 'overviewLogue'
export const ANNOTATION_SOCIAL_MEDIA = 'annotation'

export const TWITTER_ACCOUNT = 'BobtailYearling'
